import React from 'react';
import './SocialIcons.css';



const SocialIcons = () => {


    return (
        <div className="social_container">
                                
            <a  href="https://www.facebook.com/maram.phanindrareddy" target="_blank" rel="noreferrer" >
                <i className="fa fa-facebook "></i> 
            </a>
                
            <a  href="https://github.com/Phanindra-Reddy/" target="_blank" rel="noreferrer" > 
                <i className="fa fa-github "></i>
            </a>
            
            <a  href="https://www.linkedin.com/in/phanindrareddy-maram/747973145" target="_blank" rel="noreferrer" > 
                <i className="fa fa-linkedin "></i>
            </a>
                
            <a  href="mailto:mpr4070@gmail.com" target="_blank" rel="noreferrer" > 
                <i className="fa fa-envelope "></i>
            </a>
                
            <a  href="https://www.snapchat.com/add/mpr4070" target="_blank" rel="noreferrer" > 
                <i className="fa fa-snapchat-ghost "></i>
            </a>
                                 
        </div>
    )
}

export default SocialIcons;
